<script>
import vueInstagram from '@/components/vueInstagram';
import vueBandCamp from '@/components/vueBandCamp';
import youtubeContainer from '@/components/youtubeContainer';

export default {
  name: 'album10',
  components: {
    vueInstagram,
    vueBandCamp,
    youtubeContainer,
  },
  data() {
    return {
      ready: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.ready = true;
    }
  },
};
</script>

<template>
  <div class="uncommon-container" v-if="ready" :class="$mq">

    <div class="contents-container">
      <div class="contents-instagram">
        <vue-instagram :posts="['CHGDzIcHcAu']" :show-follow-btn="false"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="title">{{$t('message.shop.bandcamp')}}</div>
      <div class="contents-bandcamp">
        <vue-band-camp
          embedded-url="https://bandcamp.com/EmbeddedPlayer/album=251734625/size=large/bgcol=333333/linkcol=9a64ff/tracklist=false/transparent=true/"
          href-url="https://kyousou-gakudan.bandcamp.com/album/prologue"
          :album-title="$t('message.discography.albums.a10.name')"
          />
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'vjnton5TaFk'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'jWeotqrAwMA'"/>
      </div>
    </div>
    
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  @import "../css/albumUncommon";
</style>
